import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, TextField, withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { getCurrentWarehouse } from '../../../utilities/common';
import { getExpirationProcessingType, updateOrderExpirationProcessingType } from "../../../actions/mmActions";
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { isEmpty } from 'lodash';

const FixedTextField = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-input': {
      padding: '10px !important',
    },
    width: 300,
    marginBottom: 20,
  },
}))(TextField);

function ExpirationType(props) {
  const { t } = useTranslation('updateToolbox');
  const dispatch = useDispatch();
  const warehouseId = getCurrentWarehouse()?.id;
  const [tnos, setTnos] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [expirationTypes, setExpirationTypes] = useState([]);
  const [expirationType, setExpirationType] = useState('');
  const [loading, setLoading] = useState(false);
  const handleTnosChange = (event) => {
    setTnos(event.target.value);
  };

  useEffect(() => {
    dispatch(getExpirationProcessingType())
      .then((res) => {
        setExpirationTypes(res);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleSubmit = () => {
    const data = {
      tnos: tnos,
      expiration_type: parseInt(expirationType),
      warehouse: warehouseId,
    };

    dispatch(updateOrderExpirationProcessingType(data))
      .then((res) => {
        let message = '';
        if (res.data.invalid_tnos && res.data.invalid_tnos.length > 0) {
          const invalidTnosMessage = `Invalid TNOS: ${res.data.invalid_tnos.join(', ')}`;
          message += invalidTnosMessage;
        }
        if (res.data.valid_tnos && res.data.valid_tnos.length > 0) {
          const validTnosMessage = `Valid TNOS: ${res.data.valid_tnos.join(', ')}`;
          message += (message ? '\n' : '') + validTnosMessage;
        }
        if (message && isEmpty(res.data.invalid_tnos)) {
          dispatch(showAlertSnackbar({ message: message, type: 'success' }));
        } else {
          dispatch(showAlertSnackbar({ message: message, type: 'error' }));
        }
        setLoading(false);
      })
      .catch((error) => {
        dispatch(showAlertSnackbar({ message: error.message, type: 'error' }));
        setLoading(false);
      });
  };

  return (
    <div>
      <div>
        <FixedTextField
          variant='outlined'
          placeholder={t('input_parcel_no')}
          multiline
          rows={6}
          id="expirationtype_tno_fixtextfield"
          onChange={handleTnosChange}
        />
        <FixedTextField
          fullWidth
          select

          label={t('expiration_process_type')}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          value={expirationType}
          onChange={(e) => {
            setExpirationType(e.target.value);
          }}
          id="expirationtype_expiration_fixtextfield"
          style={{ minWidth: 200, marginLeft: 10 }}
        >
          {expirationTypes.map((expirationType) => (
            <option key={expirationType.name} value={expirationType.value}>
              {expirationType.name}
            </option>
          ))}
        </FixedTextField>
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: 10 }}
          onClick={handleSubmit}
          id="expirationtype_expiration_button"
          disabled={disabled || !(tnos && expirationType)}
        >
          {t('confirm_lot_update')}
        </Button>
      </div>
    </div>
  );
}

export default ExpirationType;
